/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const SendlaneIcon = ({
  className,
  style: styleFromProps,
  onClick,
  color = 'white',
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={classNames(className)}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="32"
      viewBox="0 0 26 32"
      fill="none"
    >
      <path
        d="M25.3974 16.0166C25.3453 14.7929 24.7722 13.6509 23.9089 12.7832C23.9089 12.7832 18.8554 7.80711 16.3622 5.32275C16.2431 5.18185 16.124 5.04094 15.9975 4.91487L12.44 1.37003C10.6166 -0.446892 7.63213 -0.461725 5.78639 1.33295L2.01305 5.01128C1.07529 5.92345 0.569201 7.1545 0.591529 8.46713C0.613856 9.72785 1.17949 10.9144 2.08003 11.7969L14.4643 24.1222L10.4082 28.1639C9.94674 28.6312 9.13551 28.6237 8.66663 28.1639L4.95283 24.4708C4.66257 24.1816 4.54349 23.7885 4.61792 23.3732C4.66257 23.1211 4.80398 22.8912 4.99004 22.7058L9.71602 18.004L7.65445 15.1341L2.48937 20.2733C1.55161 21.2078 1.05296 22.4685 1.1125 23.8033C1.1646 25.027 1.73768 26.169 2.601 27.0367L6.09153 30.5148C6.9623 31.3825 8.10845 31.9461 9.33646 31.998C10.6761 32.0573 11.9488 31.5605 12.8865 30.6261L18.1856 25.3533L24.0279 19.5392C24.9657 18.6047 25.4643 17.344 25.4048 16.0091L25.3974 16.0166ZM4.11183 8.13341C4.15648 7.88127 4.30533 7.64396 4.4914 7.46597L8.23497 3.81731C8.71129 3.3501 9.49275 3.3501 9.96163 3.82472L13.6308 7.47339C14.0252 7.86644 14.1145 8.47455 13.7796 9.02333L9.00899 13.7695L4.44674 9.23098C4.15648 8.94175 4.02996 8.54129 4.11183 8.13341ZM21.5347 17.0845L16.9352 21.6601L11.4873 16.239L16.1017 11.6485C16.3919 11.3593 16.6375 11.033 16.8385 10.6845L21.4975 15.3269C21.6835 15.5123 21.825 15.7422 21.8696 15.9943C21.944 16.4022 21.8175 16.8027 21.5347 17.0919V17.0845Z"
        fill={color}
      />
    </svg>
  );
};
